import { useParamsSearch } from '@anytag/shared-hooks';
import { ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { useFacebookPageAnalyticsPostsQuery } from '@anytag/graphql';
import { ProfilePostsCount, ProfilePostsFilter, AnalyticsFacebookPostsList } from '@anytag/shared-organisms';
import { useInitialAnalyticsPosts } from '../hooks';
import { AnalyticsFbFeedPostSearchSchemaType } from './schema-types';

export const AnalyticsFacebookPosts = () => {
  const { brandAccountId, mainSocialAccountId } = useInitialAnalyticsPosts({
    socialMedia: 'facebook'
  });
  const { page, limit, sort, filter, setFilter } = useParamsSearch<AnalyticsFbFeedPostSearchSchemaType>();
  const { data, previousData, loading } = useFacebookPageAnalyticsPostsQuery({
    skip: !brandAccountId || !mainSocialAccountId,
    variables: getValuableVariables({
      limit,
      orderBy: sort,
      offset: getOffset(page, limit),
      facebookPageAnalyticsAccountId: Number(mainSocialAccountId),
      ...filter
    })
  });

  const result = loading ? previousData : data;
  const totalRecords = result?.facebookPageAnalyticsPostsCount?.totalNumber;

  return (
    <ListWithPagination pagination={{ totalRecords }}>
      <ProfilePostsFilter filter={filter} setFilter={setFilter} hasPeriod />

      <ProfilePostsCount count={totalRecords} />

      <AnalyticsFacebookPostsList
        loading={loading}
        mainSocialAccountId={mainSocialAccountId}
        data={result?.facebookPageAnalyticsPosts.posts || []}
      />
    </ListWithPagination>
  );
};
